/**
 * Default get option selected fn
 * @param option Option
 * @param value Value
 */
export const isLabelValueAutoListOptionSelected = <
	T extends {label: string; value: number | string},
>(
	option?: T,
	value?: T | T[],
) =>
	Array.isArray(value)
		? value.some((v) => v.value === option?.value)
		: option?.value === value?.value;
